const SortOptions = [
  { key: 'name', text: '名前', value: 'name' },
  { key: 'price', text: '価格', value: 'price' },
  { key: 'costEffectiveness', text: '費用対効果', value: 'costEffectiveness' }, //TODO:変数名が長い
]

export default SortOptions
